import { Global, css, Theme } from "@emotion/react";
import { inter } from "../fonts";

const globalCss = (theme: Theme) => css`
  ${inter}

  html {
    box-sizing: border-box;
    font-family: ${theme?.fonts.body || "sans-serif"};
    font-size: ${theme?.baseFontSize || "62.5%"};
  }

  *,
  *:before,
  *:after {
    box-sizing: inherit;
    font-family: inherit;
    color: inherit;
  }

  body {
    font-family: ${theme?.fonts.body};
    color: ${theme?.palette?.foreground.base};
    margin: 0;
    padding: 0;
  }

  :root {
    --background: ${theme?.palette?.background.base};
  }

  h1 {
    font-family: ${theme?.fonts.title};
  }

  h2 {
    font-size: ${theme?.fontSize.subHeading};
  }

  p {
    font-size: ${theme?.fontSize.base};
  }
`;

export const GlobalStyles = () => <Global styles={[globalCss]} />;
